import React from 'react';
import * as Sentry from '@sentry/react';

import BasePage from './LazyBasePage';
import SearchContainer from '../SearchApp/containers/SearchContainer';
import withCookieHeaderHeight from '../components/withCookieHeaderHeight';
import EnhancedSearchConsumerHeader from '../components/EnhancedSearchConsumerHeader';
import { getSearchPageHeaderOffset } from '../components/ConsumerHeader/utils';

import ConfirmationOverlay from '../components/ConfirmationOverlay/ConfirmationOverlay';
import { OverlayProvider } from '../context/Overlay';

class SearchPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            headerOffset: getSearchPageHeaderOffset(props.cookieHeaderHeight),
        };
    }

    componentDidMount() {
        const { cookieHeaderHeight } = this.props;

        Sentry.setTag('sub_app', 'search');

        this.setState({
            headerOffset: getSearchPageHeaderOffset(cookieHeaderHeight),
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.cookieHeaderHeight !== prevProps.cookieHeaderHeight) {
            this.setState({
                headerOffset: getSearchPageHeaderOffset(
                    this.props.cookieHeaderHeight,
                ),
            });
        }
    }

    render() {
        return (
            <OverlayProvider>
                <BasePage
                    {...this.props}
                    isSearchPage={true}
                    structureHeader={EnhancedSearchConsumerHeader}
                >
                    <ConfirmationOverlay />
                    <div
                        className="feed-search-page"
                        style={{ paddingTop: this.state.headerOffset }}
                    >
                        <SearchContainer {...this.props} />
                    </div>
                </BasePage>
            </OverlayProvider>
        );
    }
}

export default withCookieHeaderHeight(SearchPage);
